import { useNavigate } from "react-router-dom";

const onRedirectCallback = (appState:any) => {
  const navigate = useNavigate();
  if (!appState?.returnTo) {
    return
  }

  navigate(appState.returnTo);
};
  
export function getAuth0Config(envName:string) {
  
    const configJson:{[key:string]:{domain:string, clientId:string, audience:string}} = {
      dev: {    
        domain: "login-dev.weareatticus.com",
        clientId: "H6KBnYBMlar1tmT2JL7FxrsfohWV7ZDC",
        audience: "https://dev-of5aa545xsyj7twy.us.auth0.com/api/v2/"
      },
      ppd1: {
        domain: "login-preprod.weareatticus.com",
        clientId: "XImL5o9nXi22JfVxCrRNsAfOixa2E1Rb",
        audience: "https://atticus-preprod.us.auth0.com/api/v2/"
      },
      prod: {
        domain: "login.weareatticus.com",
        clientId: "T61qgKSBwImnaiCii0j7rXPAf24ZTTzY",
        audience: "https://atticus-prod.us.auth0.com/api/v2/"
      }
    }
  
    return {
      domain: configJson[envName].domain,
      clientId: configJson[envName].clientId,
      onRedirectCallback,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: configJson[envName].audience,
      },
    }
  }